/* @generated from adl module totalinteraction.futurefit.lpapi */

import * as ADL from './../../runtime/adl';

/**
 * Scodle-specific - TODO: generalize
 */
export interface ErrorResponse {
  code: number;
  error: string;
}

export function makeErrorResponse(
  input: {
    code: number,
    error: string,
  }
): ErrorResponse {
  return {
    code: input.code,
    error: input.error,
  };
}

const ErrorResponse_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.lpapi","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"code","default":{"kind":"nothing"},"name":"code","typeExpr":{"typeRef":{"kind":"primitive","value":"Int64"},"parameters":[]}},{"annotations":[],"serializedName":"error","default":{"kind":"nothing"},"name":"error","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}]}},"name":"ErrorResponse","version":{"kind":"nothing"}}};

export const snErrorResponse: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.lpapi", name:"ErrorResponse"};

export function texprErrorResponse(): ADL.ATypeExpr<ErrorResponse> {
  return {value : {typeRef : {kind: "reference", value : snErrorResponse}, parameters : []}};
}

export interface ResultsType<T> {
  results: T[];
}

export function makeResultsType<T>(
  input: {
    results: T[],
  }
): ResultsType<T> {
  return {
    results: input.results,
  };
}

const ResultsType_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.lpapi","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":["T"],"fields":[{"annotations":[],"serializedName":"results","default":{"kind":"nothing"},"name":"results","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"typeParam","value":"T"},"parameters":[]}]}}]}},"name":"ResultsType","version":{"kind":"nothing"}}};

export const snResultsType: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.lpapi", name:"ResultsType"};

export function texprResultsType<T>(texprT : ADL.ATypeExpr<T>): ADL.ATypeExpr<ResultsType<T>> {
  return {value : {typeRef : {kind: "reference", value : {moduleName : "totalinteraction.futurefit.lpapi",name : "ResultsType"}}, parameters : [texprT.value]}};
}

export interface ResponseType_Results<R> {
  kind: 'results';
  value: R;
}
export interface ResponseType_ErrorResponse<_R> {
  kind: 'errorResponse';
  value: ErrorResponse;
}

export type ResponseType<R> = ResponseType_Results<R> | ResponseType_ErrorResponse<R>;

const ResponseType_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.lpapi","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":["R"],"fields":[{"annotations":[],"serializedName":"results","default":{"kind":"nothing"},"name":"results","typeExpr":{"typeRef":{"kind":"typeParam","value":"R"},"parameters":[]}},{"annotations":[],"serializedName":"errorResponse","default":{"kind":"nothing"},"name":"errorResponse","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.lpapi","name":"ErrorResponse"}},"parameters":[]}}]}},"name":"ResponseType","version":{"kind":"nothing"}}};

export const snResponseType: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.lpapi", name:"ResponseType"};

export function texprResponseType<R>(texprR : ADL.ATypeExpr<R>): ADL.ATypeExpr<ResponseType<R>> {
  return {value : {typeRef : {kind: "reference", value : {moduleName : "totalinteraction.futurefit.lpapi",name : "ResponseType"}}, parameters : [texprR.value]}};
}

/**
 * Starting with Scodle...
 */
export interface CatalogEntry {
  courseid: string;
  name: string;
  shortname: string;
  description: string;
  /**
   * TODO: translate to Instant. Date formats are "2015-11-25T13:00:00Z"
   */
  startdate: string;
  enrolperiod: string;
  /**
   * TODO: translate to Instant. Date formats are "2015-11-25T13:00:00Z"
   */
  enrolstartdate: (string|null);
  enrolenddate: (string|null);
}

export function makeCatalogEntry(
  input: {
    courseid: string,
    name: string,
    shortname: string,
    description: string,
    startdate: string,
    enrolperiod: string,
    enrolstartdate: (string|null),
    enrolenddate: (string|null),
  }
): CatalogEntry {
  return {
    courseid: input.courseid,
    name: input.name,
    shortname: input.shortname,
    description: input.description,
    startdate: input.startdate,
    enrolperiod: input.enrolperiod,
    enrolstartdate: input.enrolstartdate,
    enrolenddate: input.enrolenddate,
  };
}

const CatalogEntry_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.lpapi","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"courseid","default":{"kind":"nothing"},"name":"courseid","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"name","default":{"kind":"nothing"},"name":"name","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"shortname","default":{"kind":"nothing"},"name":"shortname","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"description","default":{"kind":"nothing"},"name":"description","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"startdate","default":{"kind":"nothing"},"name":"startdate","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"enrolperiod","default":{"kind":"nothing"},"name":"enrolperiod","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"enrolstartdate","default":{"kind":"nothing"},"name":"enrolstartdate","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[],"serializedName":"enrolenddate","default":{"kind":"nothing"},"name":"enrolenddate","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}}]}},"name":"CatalogEntry","version":{"kind":"nothing"}}};

export const snCatalogEntry: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.lpapi", name:"CatalogEntry"};

export function texprCatalogEntry(): ADL.ATypeExpr<CatalogEntry> {
  return {value : {typeRef : {kind: "reference", value : snCatalogEntry}, parameters : []}};
}

/**
 * Used in LPAPI Requests (for Scodle return value), and generally in the client
 */
export type Catalog = ResultsType<CatalogEntry>;

const Catalog_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.lpapi","decl":{"annotations":[],"type_":{"kind":"type_","value":{"typeParams":[],"typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.lpapi","name":"ResultsType"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.lpapi","name":"CatalogEntry"}},"parameters":[]}]}}},"name":"Catalog","version":{"kind":"nothing"}}};

export const snCatalog: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.lpapi", name:"Catalog"};

export function texprCatalog(): ADL.ATypeExpr<Catalog> {
  return {value : {typeRef : {kind: "reference", value : snCatalog}, parameters : []}};
}

/**
 * Used in Requests
 */
export type CatalogResp = ResponseType<Catalog>;

const CatalogResp_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.lpapi","decl":{"annotations":[],"type_":{"kind":"type_","value":{"typeParams":[],"typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.lpapi","name":"ResponseType"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.lpapi","name":"Catalog"}},"parameters":[]}]}}},"name":"CatalogResp","version":{"kind":"nothing"}}};

export const snCatalogResp: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.lpapi", name:"CatalogResp"};

export function texprCatalogResp(): ADL.ATypeExpr<CatalogResp> {
  return {value : {typeRef : {kind: "reference", value : snCatalogResp}, parameters : []}};
}

export interface User {
  userid: string;
  firstname: string;
  lastname: string;
  email: string;
  profileurl: string;
  loginurl: string;
}

export function makeUser(
  input: {
    userid: string,
    firstname: string,
    lastname: string,
    email: string,
    profileurl: string,
    loginurl: string,
  }
): User {
  return {
    userid: input.userid,
    firstname: input.firstname,
    lastname: input.lastname,
    email: input.email,
    profileurl: input.profileurl,
    loginurl: input.loginurl,
  };
}

const User_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.lpapi","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"userid","default":{"kind":"nothing"},"name":"userid","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"firstname","default":{"kind":"nothing"},"name":"firstname","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"lastname","default":{"kind":"nothing"},"name":"lastname","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"email","default":{"kind":"nothing"},"name":"email","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"profileurl","default":{"kind":"nothing"},"name":"profileurl","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"loginurl","default":{"kind":"nothing"},"name":"loginurl","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}]}},"name":"User","version":{"kind":"nothing"}}};

export const snUser: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.lpapi", name:"User"};

export function texprUser(): ADL.ATypeExpr<User> {
  return {value : {typeRef : {kind: "reference", value : snUser}, parameters : []}};
}

/**
 * Used in LPAPI Requests (for Scodle return value)
 */
export type Users = ResultsType<User>;

const Users_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.lpapi","decl":{"annotations":[],"type_":{"kind":"type_","value":{"typeParams":[],"typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.lpapi","name":"ResultsType"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.lpapi","name":"User"}},"parameters":[]}]}}},"name":"Users","version":{"kind":"nothing"}}};

export const snUsers: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.lpapi", name:"Users"};

export function texprUsers(): ADL.ATypeExpr<Users> {
  return {value : {typeRef : {kind: "reference", value : snUsers}, parameters : []}};
}

/**
 * Used in Requests
 */
export type UserQueryResp = ResponseType<Users>;

const UserQueryResp_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.lpapi","decl":{"annotations":[],"type_":{"kind":"type_","value":{"typeParams":[],"typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.lpapi","name":"ResponseType"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.lpapi","name":"Users"}},"parameters":[]}]}}},"name":"UserQueryResp","version":{"kind":"nothing"}}};

export const snUserQueryResp: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.lpapi", name:"UserQueryResp"};

export function texprUserQueryResp(): ADL.ATypeExpr<UserQueryResp> {
  return {value : {typeRef : {kind: "reference", value : snUserQueryResp}, parameters : []}};
}

/**
 * Used in Requests
 */
export type UserCreateResp = ResponseType<User>;

const UserCreateResp_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.lpapi","decl":{"annotations":[],"type_":{"kind":"type_","value":{"typeParams":[],"typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.lpapi","name":"ResponseType"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.lpapi","name":"User"}},"parameters":[]}]}}},"name":"UserCreateResp","version":{"kind":"nothing"}}};

export const snUserCreateResp: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.lpapi", name:"UserCreateResp"};

export function texprUserCreateResp(): ADL.ATypeExpr<UserCreateResp> {
  return {value : {typeRef : {kind: "reference", value : snUserCreateResp}, parameters : []}};
}

export interface UserCreateReq {
  email: string;
  firstname: string;
  lastname: string;
}

export function makeUserCreateReq(
  input: {
    email: string,
    firstname: string,
    lastname: string,
  }
): UserCreateReq {
  return {
    email: input.email,
    firstname: input.firstname,
    lastname: input.lastname,
  };
}

const UserCreateReq_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.lpapi","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"email","default":{"kind":"nothing"},"name":"email","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"firstname","default":{"kind":"nothing"},"name":"firstname","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"lastname","default":{"kind":"nothing"},"name":"lastname","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}]}},"name":"UserCreateReq","version":{"kind":"nothing"}}};

export const snUserCreateReq: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.lpapi", name:"UserCreateReq"};

export function texprUserCreateReq(): ADL.ATypeExpr<UserCreateReq> {
  return {value : {typeRef : {kind: "reference", value : snUserCreateReq}, parameters : []}};
}

export interface Enrolment {
  enrolmentid: string;
  userid: string;
  courseid: string;
}

export function makeEnrolment(
  input: {
    enrolmentid: string,
    userid: string,
    courseid: string,
  }
): Enrolment {
  return {
    enrolmentid: input.enrolmentid,
    userid: input.userid,
    courseid: input.courseid,
  };
}

const Enrolment_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.lpapi","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"enrolmentid","default":{"kind":"nothing"},"name":"enrolmentid","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"userid","default":{"kind":"nothing"},"name":"userid","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"courseid","default":{"kind":"nothing"},"name":"courseid","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}]}},"name":"Enrolment","version":{"kind":"nothing"}}};

export const snEnrolment: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.lpapi", name:"Enrolment"};

export function texprEnrolment(): ADL.ATypeExpr<Enrolment> {
  return {value : {typeRef : {kind: "reference", value : snEnrolment}, parameters : []}};
}

/**
 * Used in LPAPI Requests (for Scodle return value)
 */
export type Enrolments = ResultsType<Enrolment>;

const Enrolments_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.lpapi","decl":{"annotations":[],"type_":{"kind":"type_","value":{"typeParams":[],"typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.lpapi","name":"ResultsType"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.lpapi","name":"Enrolment"}},"parameters":[]}]}}},"name":"Enrolments","version":{"kind":"nothing"}}};

export const snEnrolments: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.lpapi", name:"Enrolments"};

export function texprEnrolments(): ADL.ATypeExpr<Enrolments> {
  return {value : {typeRef : {kind: "reference", value : snEnrolments}, parameters : []}};
}

/**
 * Used in Requests
 */
export type EnrolmentQueryResp = ResponseType<Enrolments>;

const EnrolmentQueryResp_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.lpapi","decl":{"annotations":[],"type_":{"kind":"type_","value":{"typeParams":[],"typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.lpapi","name":"ResponseType"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.lpapi","name":"Enrolments"}},"parameters":[]}]}}},"name":"EnrolmentQueryResp","version":{"kind":"nothing"}}};

export const snEnrolmentQueryResp: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.lpapi", name:"EnrolmentQueryResp"};

export function texprEnrolmentQueryResp(): ADL.ATypeExpr<EnrolmentQueryResp> {
  return {value : {typeRef : {kind: "reference", value : snEnrolmentQueryResp}, parameters : []}};
}

/**
 * Used in Requests
 */
export type EnrolmentCreateResp = ResponseType<Enrolment>;

const EnrolmentCreateResp_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.lpapi","decl":{"annotations":[],"type_":{"kind":"type_","value":{"typeParams":[],"typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.lpapi","name":"ResponseType"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.lpapi","name":"Enrolment"}},"parameters":[]}]}}},"name":"EnrolmentCreateResp","version":{"kind":"nothing"}}};

export const snEnrolmentCreateResp: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.lpapi", name:"EnrolmentCreateResp"};

export function texprEnrolmentCreateResp(): ADL.ATypeExpr<EnrolmentCreateResp> {
  return {value : {typeRef : {kind: "reference", value : snEnrolmentCreateResp}, parameters : []}};
}

export interface EnrolmentCreateReq {
  userid: string;
  courseid: string;
}

export function makeEnrolmentCreateReq(
  input: {
    userid: string,
    courseid: string,
  }
): EnrolmentCreateReq {
  return {
    userid: input.userid,
    courseid: input.courseid,
  };
}

const EnrolmentCreateReq_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.lpapi","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"userid","default":{"kind":"nothing"},"name":"userid","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"courseid","default":{"kind":"nothing"},"name":"courseid","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}]}},"name":"EnrolmentCreateReq","version":{"kind":"nothing"}}};

export const snEnrolmentCreateReq: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.lpapi", name:"EnrolmentCreateReq"};

export function texprEnrolmentCreateReq(): ADL.ATypeExpr<EnrolmentCreateReq> {
  return {value : {typeRef : {kind: "reference", value : snEnrolmentCreateReq}, parameters : []}};
}

export const _AST_MAP: { [key: string]: ADL.ScopedDecl } = {
  "totalinteraction.futurefit.lpapi.ErrorResponse" : ErrorResponse_AST,
  "totalinteraction.futurefit.lpapi.ResultsType" : ResultsType_AST,
  "totalinteraction.futurefit.lpapi.ResponseType" : ResponseType_AST,
  "totalinteraction.futurefit.lpapi.CatalogEntry" : CatalogEntry_AST,
  "totalinteraction.futurefit.lpapi.Catalog" : Catalog_AST,
  "totalinteraction.futurefit.lpapi.CatalogResp" : CatalogResp_AST,
  "totalinteraction.futurefit.lpapi.User" : User_AST,
  "totalinteraction.futurefit.lpapi.Users" : Users_AST,
  "totalinteraction.futurefit.lpapi.UserQueryResp" : UserQueryResp_AST,
  "totalinteraction.futurefit.lpapi.UserCreateResp" : UserCreateResp_AST,
  "totalinteraction.futurefit.lpapi.UserCreateReq" : UserCreateReq_AST,
  "totalinteraction.futurefit.lpapi.Enrolment" : Enrolment_AST,
  "totalinteraction.futurefit.lpapi.Enrolments" : Enrolments_AST,
  "totalinteraction.futurefit.lpapi.EnrolmentQueryResp" : EnrolmentQueryResp_AST,
  "totalinteraction.futurefit.lpapi.EnrolmentCreateResp" : EnrolmentCreateResp_AST,
  "totalinteraction.futurefit.lpapi.EnrolmentCreateReq" : EnrolmentCreateReq_AST
};



// WEBPACK FOOTER //
// ./src/adl-gen/totalinteraction/futurefit/lpapi.ts